module.exports = __webpack_public_path__ + "static/media/two.91651ba2.svg";